import { IsString } from 'class-validator';

export class OrderCachePaymentResponseRequestDto {
  @IsString()
  rawBase64: string;

  @IsString()
  decodedResponse: string;
}
